import { memo, useState } from "react";
import clsx from "clsx";
import ProductImage from "./ProductImage";

export const ProductGallery = memo(({ images }: { images: string[] }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const safeImages = images?.length ? images : [];
  const mainImage = safeImages[selectedIndex] ?? safeImages[0];

  return (
    <div className="relative w-full mt-6">
      <div className="w-full bg-white border border-gray-200 rounded-xl shadow-sm p-4">
        {/* Main image */}
        <div className="flex justify-center items-center rounded-xl overflow-hidden bg-white border border-gray-100">
          <div className="relative w-full aspect-square max-h-96 rounded-xl">
            {mainImage && (
              <ProductImage
                key={mainImage}
                src={mainImage}
                alt="Product Image"
                className="rounded-xl object-contain"
              />
            )}
          </div>
        </div>

        {/* Thumbnail boxes - full width grid only when more than 3 images */}
        {safeImages.length > 1 &&
          (safeImages.length > 3 ? (
            <div
              className="grid gap-2 mt-4 w-full"
              style={{
                gridTemplateColumns: `repeat(${safeImages.length}, minmax(0, 1fr))`,
              }}
            >
              {safeImages.map((image, i) => (
                <button
                  key={image}
                  type="button"
                  onClick={() => setSelectedIndex(i)}
                  className={clsx(
                    "relative aspect-square min-w-0 rounded-lg overflow-hidden border-2 transition-all focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1",
                    i === selectedIndex
                      ? "border-primary ring-1 ring-primary"
                      : "border-gray-200 hover:border-gray-300",
                  )}
                  aria-label={`View image ${i + 1}`}
                  aria-pressed={i === selectedIndex}
                >
                  <ProductImage
                    src={image}
                    alt={`Thumbnail ${i + 1}`}
                    className="object-contain w-full h-full"
                  />
                </button>
              ))}
            </div>
          ) : (
            <div className="flex gap-2 justify-center mt-4 flex-wrap">
              {safeImages.map((image, i) => (
                <button
                  key={image}
                  type="button"
                  onClick={() => setSelectedIndex(i)}
                  className={clsx(
                    "relative h-20 w-20 flex-shrink-0 rounded-lg overflow-hidden border-2 transition-all focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1",
                    i === selectedIndex
                      ? "border-primary ring-1 ring-primary"
                      : "border-gray-200 hover:border-gray-300",
                  )}
                  aria-label={`View image ${i + 1}`}
                  aria-pressed={i === selectedIndex}
                >
                  <ProductImage
                    src={image}
                    alt={`Thumbnail ${i + 1}`}
                    className="object-contain w-full h-full"
                  />
                </button>
              ))}
            </div>
          ))}
      </div>
    </div>
  );
});
